import { BadgeButton } from '../base/badge'

interface Props {
  event: {
    id: string
    description: string
    state: 'pending' | 'confirmed' | 'cancelled'
  }
}

export const CalendarCard = ({ event }: Props) => {
  const color = () => {
    switch (event.state) {
      case 'pending': return 'yellow'
      case 'confirmed': return 'green'
      case 'cancelled': return 'red'
    }
  }

  return (
    <>
      <span>
        <BadgeButton color={color()} href={`/events/${event.id}`}>{ event.description }</BadgeButton>
      </span>
    </>
  )
}
